import { FaDiscord, FaLinkedin } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import privacyPolicy from "../../../assets/privacy_policy.md?raw";
import termsOfService from "../../../assets/terms_of_service.md?raw";
import { SOCIALS_CONFIG } from "../../../config/socials_config";
import { useIsCompactView } from "../../../core_stores/useIsCompactViewStore";
import { useFaqModal } from "../../../providers/FaqModalProvider";
import { usePrivacyTermsModal } from "../../../providers/PrivacyTermsModalProvider";
import { useSubscriptionsModal } from "../../../providers/SubscriptionsModalProvider";

export function WelcomeFooter() {
  const isCompactView = useIsCompactView();

  const { show: showPrivacyTermsModal } = usePrivacyTermsModal();
  const { show: showFaqModal } = useFaqModal();
  const { open: openSubscriptionsModal } = useSubscriptionsModal();

  const hoverStyle = "hover:text-slate-300 transition-colors";

  const openPrivacyPolicy = () => {
    showPrivacyTermsModal(privacyPolicy);
  };

  const openTermsOfService = () => {
    showPrivacyTermsModal(termsOfService);
  };

  return (
    <div
      className={`${
        isCompactView ? "px-4 pt-6 pb-12 flex-col gap-8" : "p-8 flex-row gap-12"
      } w-full flex items-center justify-between z-10 
      bg-[#989CA9] dark:bg-[#181A1D] 
      text-white dark:text-dark-text`}
    >
      <div
        className={`flex gap-2 lg:gap-6 text-sm ${
          isCompactView ? "flex-col items-center" : "flex-row"
        }`}
      >
        {isCompactView && (
          <>
            <button
              id="home-pricing-footer"
              onClick={openSubscriptionsModal}
              className={hoverStyle}
            >
              Pricing
            </button>
            <button onClick={showFaqModal} className={hoverStyle}>
              FAQ
            </button>
            <a href="blog" className={hoverStyle}>
              Blog
            </a>
          </>
        )}
        <button onClick={openPrivacyPolicy} className={hoverStyle}>
          Privacy Policy
        </button>
        <button onClick={openTermsOfService} className={hoverStyle}>
          Terms & Conditions
        </button>
        {!isCompactView && (
          <>
            <button onClick={showFaqModal} className={hoverStyle}>
              FAQ
            </button>
            <a href="blog" className={hoverStyle}>
              Blog
            </a>
          </>
        )}
      </div>

      <div className="flex items-center gap-6">
        <a
          href="https://discord.gg/Qkn5JfZMDN"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaDiscord className={`${hoverStyle} w-5 h-5`} />
        </a>
        <a
          href={SOCIALS_CONFIG.linkedin}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaLinkedin className={`${hoverStyle} w-5 h-5`} />
        </a>
        <a href={SOCIALS_CONFIG.x} target="_blank" rel="noopener noreferrer">
          <FaXTwitter className={`${hoverStyle} w-5 h-5`} />
        </a>
      </div>
    </div>
  );
}
